// src/components/settings/NotificationSettings.jsx
import React, { useState } from 'react';
import { Bell, Mail, Smartphone, Save } from 'lucide-react';

const NotificationSettings = ({ onUnsavedChanges }) => {
  const [settings, setSettings] = useState({
    emailNotifications: true,
    pushNotifications: true,
    taskReminders: true,
    weeklyReports: false,
    collaborationUpdates: true,
    systemUpdates: true
  });

  const handleChange = (setting) => {
    setSettings(prev => ({
      ...prev,
      [setting]: !prev[setting]
    }));
    onUnsavedChanges(true);
  };

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log('Saving notification settings:', settings);
    onUnsavedChanges(false);
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h3 className="text-lg font-medium text-gray-900">Notification Preferences</h3>
        <p className="text-sm text-gray-600">Choose how you want to be notified about important updates</p>
      </div>

      <div className="space-y-6">
        {/* Email Notifications */}
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Mail className="w-5 h-5 text-gray-500" />
            <h4 className="font-medium text-gray-900">Email Notifications</h4>
          </div>
          
          <div className="space-y-3 ml-7">
            {[
              { key: 'emailNotifications', label: 'Email notifications', desc: 'Receive email updates about your account' },
              { key: 'taskReminders', label: 'Task reminders', desc: 'Get reminded about upcoming task deadlines' },
              { key: 'weeklyReports', label: 'Weekly reports', desc: 'Receive weekly summary reports' },
              { key: 'collaborationUpdates', label: 'Collaboration updates', desc: 'Updates when others share tasks with you' }
            ].map((item) => (
              <div key={item.key} className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-900">{item.label}</div>
                  <div className="text-xs text-gray-500">{item.desc}</div>
                </div>
                <button
                  onClick={() => handleChange(item.key)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                    settings[item.key] ? 'bg-blue-600' : 'bg-gray-200'
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      settings[item.key] ? 'translate-x-6' : 'translate-x-1'
                    }`}
                  />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Push Notifications */}
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Smartphone className="w-5 h-5 text-gray-500" />
            <h4 className="font-medium text-gray-900">Push Notifications</h4>
          </div>
          
          <div className="space-y-3 ml-7">
            {[
              { key: 'pushNotifications', label: 'Push notifications', desc: 'Receive push notifications in your browser' },
              { key: 'systemUpdates', label: 'System updates', desc: 'Important updates about the platform' }
            ].map((item) => (
              <div key={item.key} className="flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-900">{item.label}</div>
                  <div className="text-xs text-gray-500">{item.desc}</div>
                </div>
                <button
                  onClick={() => handleChange(item.key)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                    settings[item.key] ? 'bg-blue-600' : 'bg-gray-200'
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      settings[item.key] ? 'translate-x-6' : 'translate-x-1'
                    }`}
                  />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="mt-8 pt-6 border-t border-gray-200">
        <button
          onClick={handleSave}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium"
        >
          <Save className="w-4 h-4" />
          Save Preferences
        </button>
      </div>
    </div>
  );
};

export default NotificationSettings;